import React from "react";
import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { resolveImage, formatPrice } from "@/lib/api";

const CONDITION_STYLES = {
  Nuovo: "bg-emerald-500 text-white",
  Usato: "bg-blue-500 text-white",
  Vintage: "bg-purple-500 text-white",
};

export default function ProductCard({ product }) {
  const img = resolveImage(product.images?.[0]) || "https://images.unsplash.com/photo-1570380888289-13cc37a74a0a?auto=format&fit=crop&w=600";
  const outOfStock = Number(product.quantity || 0) <= 0;
  const hasSale = product.sale_price != null && product.sale_price < product.price;

  return (
    <Link
      to={`/prodotto/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block bg-white rounded-2xl border border-border overflow-hidden hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] transition"
    >
      <div className="relative aspect-square overflow-hidden bg-slate-100">
        <img
          src={img}
          alt={product.title}
          loading="lazy"
          className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 ${outOfStock ? "opacity-60" : ""}`}
        />
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          <Badge className={`${CONDITION_STYLES[product.condition] || "bg-slate-700 text-white"} text-[10px] uppercase tracking-wider font-bold`}>
            {product.condition}
          </Badge>
          {hasSale && !outOfStock && (
            <Badge className="bg-brand-yellow text-brand-blue text-[10px] uppercase tracking-wider font-bold">
              Offerta
            </Badge>
          )}
        </div>
        {outOfStock && (
          <div className="absolute inset-0 flex items-center justify-center">
            <span data-testid="out-of-stock-label" className="px-3 py-1 rounded-full bg-slate-900/85 text-white text-xs font-bold uppercase tracking-widest">
              Esaurito
            </span>
          </div>
        )}
      </div>
      <div className="p-3">
        {product.brand && (
          <div className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">{product.brand}</div>
        )}
        <div className="font-heading font-bold text-sm text-slate-900 line-clamp-2 min-h-[2.5rem] mt-0.5">
          {product.title}
        </div>
        <div className="mt-2 flex items-baseline gap-2">
          {hasSale ? (
            <>
              <span className="font-heading font-black text-brand-blue">{formatPrice(product.sale_price)}</span>
              <span className="text-xs text-slate-400 line-through">{formatPrice(product.price)}</span>
            </>
          ) : (
            <span className="font-heading font-black text-brand-blue">{formatPrice(product.price)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
